/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import CheckinstokengoalsAnswers from './CheckinstokengoalsAnswers';

/**
 * The TokenGoalsBody model module.
 * @module model/TokenGoalsBody
 * @version v0.3
 */
export default class TokenGoalsBody {
  /**
   * Constructs a new <code>TokenGoalsBody</code>.
   * @alias module:model/TokenGoalsBody
   * @class
   * @param sessionToken {String}
   * @param answers {Array.<module:model/CheckinstokengoalsAnswers>}
   */
  constructor(sessionToken, answers) {
    this.sessionToken = sessionToken;
    this.answers = answers;
  }

  /**
   * Constructs a <code>TokenGoalsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TokenGoalsBody} obj Optional instance to populate.
   * @return {module:model/TokenGoalsBody} The populated <code>TokenGoalsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TokenGoalsBody();
      if (data.hasOwnProperty('session_token'))
        obj.sessionToken = ApiClient.convertToType(data['session_token'], 'String');
      if (data.hasOwnProperty('answers'))
        obj.answers = ApiClient.convertToType(data['answers'], [CheckinstokengoalsAnswers]);
    }
    return obj;
  }
}

/**
 * @member {String} sessionToken
 */
TokenGoalsBody.prototype.sessionToken = undefined;

/**
 * @member {Array.<module:model/CheckinstokengoalsAnswers>} answers
 */
TokenGoalsBody.prototype.answers = undefined;
